module.exports = __webpack_public_path__ + "img/belleza.af20cdc2.png";